import { useState, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import Loader from "../UI/Loader/Loader";
import classes from "./Live.module.css";
import mainclasses from "../../style.module.css";
import YouTube from "react-youtube";
import API from "../../Api";
const Live = () => {
  const [liveFeedData, setLiveFeedData] = useState({ data: [] });
  const [isLoading, setIsLoading] = useState(false);
  const opts = {
    height: "450",
    width: "800",
    playerVars: {
      autoplay: 1,
      rel: 0,
      origin:"https://myrajshree.com"
    },
  };
  const fetchLiveFeedData = useCallback(async () => {
    setIsLoading(true);
    try {
      API.get(`get-live-feed-result`)
        .then((res) => {
          setLiveFeedData(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }, []);
  useEffect(() => {
    fetchLiveFeedData();
  }, [fetchLiveFeedData]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <Helmet>
        <title>Rajshree Lottery Live Draws | Rajshree Lottery</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="description"
          content="Here you can watch rajshree lottery results live. Get live results of rajshree lottery."
        />
      </Helmet>
      <div className="flex-fill">
        <div className="container-fluid mt-2">
          <div className="row">
            <div className="col-md-8 mx-auto text-center">
              <h2 className={mainclasses.head}>Live Draw</h2>
            </div>
          </div>
        </div>
        <div className="container-fluid mt-2">
          <div className="row">
            <div className="col-md-10 mx-auto text-center">
              <YouTube videoId={liveFeedData.latestVideoId} opts={opts} />
            </div>
          </div>
        </div>
        <hr />
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-md-11 mx-auto text-center">
              <h2 className={mainclasses.head}>Old Results</h2>
            </div>
          </div>
        </div>

        <div className="container-fluid mt-4">
          <div className="row">
            <div className="col-md-11 mx-auto">
              <div className="row">
                <div className="col-lg-4 mt-3">
                  <iframe
                    width="100%"
                    height="315"
                    title="YouTube video player"
                    src="https://www.youtube.com/embed/?list=PLupmT0PG0PgMeuWuCmmatb5GqRnqdYJi3&index=1"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="col-lg-4 mt-3">
                  <iframe
                    width="100%"
                    height="315"
                    title="YouTube video player"
                    src="https://www.youtube.com/embed/?list=PLupmT0PG0PgMeuWuCmmatb5GqRnqdYJi3&index=2"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="col-lg-4 mt-3">
                  <iframe
                    width="100%"
                    height="315"
                    title="YouTube video player"
                    src="https://www.youtube.com/embed/?list=PLupmT0PG0PgMeuWuCmmatb5GqRnqdYJi3&index=3"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-lg-5 mx-auto text-center">
              <h3 className={mainclasses.head1}>
                Rajshree Lottery Live Draw | Rajshree Lottery Result Live
              </h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Live;
